/**
 * TierSvgCanvas — minimal SVG renderer.
 *
 * Renders pre-processed tier SVG HTML produced by `processTierSvg`.
 * Zero logic, zero state — all interaction is handled imperatively
 * by `useSvgProductInteraction` from the parent.
 *
 * The `key` prop must be changed by the parent when SVG content changes
 * (e.g. on tier/building switch) to force a full DOM remount so the
 * event-listener `useEffect` in the parent re-fires cleanly.
 */
export function TierSvgCanvas({ svgLayer }) {
  if (!svgLayer) return null
  return (
    <div
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: svgLayer }}
      style={{ width: '100%', height: '100%' }}
    />
  )
}
